import React from 'react'
import { Button, Tooltip } from 'antd'
import { Copy } from 'lucide-react'
import { Group, LineItem } from '../../types/ffe'
import { useFFEStore } from '../../store/ffeStore'

interface Props {
  className?: string
  item: LineItem
  group?: Group
  disabled?: boolean
}

export const DuplicateButton: React.FC<Props> = ({
  className,
  item,
  group,
  disabled
}) => {
  const addLineItem = useFFEStore((state) => state.addLineItem)

  const duplicateLineItem = () => {
    addLineItem(
      {
        ...item,
        materials: item.materials?.map((m) => ({
          ...m,
          id: crypto.randomUUID()
        })),
        groupId: group?.id,
        purchaseOrderId: undefined,
        status: 'specified'
      },
      item.id
    )
  }

  return (
    <Tooltip title="Duplicate">
      <Button
        disabled={disabled}
        type="text"
        icon={<Copy className="h-4 w-4" />}
        onClick={duplicateLineItem}
        className={className}
      />
    </Tooltip>
  )
}
